import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const CheckmarkIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.49989 13.475L4.02489 9.99999L2.84155 11.175L7.49989 15.8333L17.4999 5.83333L16.3249 4.65833L7.49989 13.475Z"
                fill={props.htmlColor ?? '#2196F3'}
            />
        </SvgIcon>
    );
};
